import { classNames, renderChildren } from '@fold-dev/core'
import { ReactNode, useEffect, useRef, useState } from 'react'

export type SlidePanelsProps = {
    panel: number
    children: ReactNode
}

export const SlidePanel = (props) => {
    const { panel, children } = props
    const [overflow, setOverflow] = useState('visible')
    const panelCache = useRef(panel)
    const timeout = useRef(null)
    const [forward, setForward] = useState(false)
    const [backward, setBackward] = useState(false)
    const className = classNames({
        'slide-panel__panel': true,
        'go-forward': forward,
        'go-back': backward,
    })

    useEffect(() => {
        clearTimeout(timeout.current)

        setOverflow('hidden')

        if (panel > panelCache.current) {
            setForward(true)
            setBackward(false)
        }

        if (panel < panelCache.current) {
            setForward(false)
            setBackward(true)
        }

        panelCache.current = panel

        timeout.current = setTimeout(() => setOverflow('visible'), 300)
    }, [panel])

    return (
        <div
            style={{ overflow }}
            className="slide-panel">
            {renderChildren(children, (child, index) => (
                <>
                    {index == panel && (
                        <div
                            key={index}
                            className={className}>
                            {child}
                        </div>
                    )}
                </>
            ))}
        </div>
    )
}
